import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SelfLearnService } from 'projects/selflearnv2-ui/src/app/services/self-learn/self-learn.service';

@Component({
  selector: 'app-practice-topic-list',
  templateUrl: './practice-topic-list.component.html',
  styleUrls: ['./practice-topic-list.component.css']
})
export class PracticeTopicListComponent implements OnInit {

  title: string = 'All Topics';
  tabPracticeTopicData:any = [];
  constructor(public router: Router, public selfLearnService:SelfLearnService) { }

  ngOnInit(): void {
    this.getTopicsByChapterExamSubtenant();
  }

  getTopicsByChapterExamSubtenant(){
    this.selfLearnService.getTopicsByChapterExamSubtenant().subscribe((resp:any) => {
      this.tabPracticeTopicData = resp?.data;
      this.getPracticeProgress();
    })
  }

  getPracticeProgress(){
    this.selfLearnService.getPracticeProgress().subscribe((resp:any) => {
      if(resp?.data == null) return;
      this.tabPracticeTopicData = this.tabPracticeTopicData.map((item:any, row:any) => {
        let found = resp?.data?.find((element:any) => item.topicId == element.topicId);
        if(!found){found = {};found['levelsInProgress'] = found['levelsCompleted'] = 0}
        return {...item, ...found};
      });
      console.log(this.tabPracticeTopicData);
    })
  }

  navigateToPracticePage() {
    this.router.navigateByUrl('selfLearn-V2/chapter');
  }

}
